module.exports = __webpack_public_path__ + "static/media/leaflet.d40267d3.png";